import { __decorate } from "tslib";
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Observer from '@slickdeals/durango/dist/javascript/observers/observer';
import { name as buttonApiName } from './buttonApi';
import { eventName as dealDetailsPageViewEventName } from '../observers/dealDetailsPageViewObservable';
import { eventName as dealDetailsPageOutclickEventName } from '../observers/dealDetailsPageOutClickObservable';
export const name = 'ButtonObserver';
export const dependencies = Object.assign({}, Injector.createDependency(buttonApiName, InjectorScope.Singleton));
let ButtonObserver = class ButtonObserver extends Observer {
    constructor(buttonApi) {
        super();
        this.buttonApi = buttonApi;
    }
    observe(observable, eventName = '') {
        this.registerCallback(this.onEvent.bind(this), observable, eventName);
    }
    onEvent(data, eventName) {
        if (eventName === dealDetailsPageViewEventName) {
            this.buttonApi.trackDealDetailsView();
            return;
        }
        if (eventName === dealDetailsPageOutclickEventName) {
            this.buttonApi.trackDealDetailsOutclick();
        }
    }
};
ButtonObserver = __decorate([
    injectable(name, dependencies)
], ButtonObserver);
export default ButtonObserver;
